var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoNoText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1280 769",
    style: {
      enableBackground: "new 0 0 1280 769"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#57BE87;}\r\n\t.st1{fill:#098C80;}\r\n\t.st2{fill:#043E44;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M168.02,454.14c0,12.26,0,24.29,0,36.31c-19.03,0.28-49.96-10.3-68-28.37c8.73-8.55,17.45-17.11,26.28-25.76 C138.22,446.81,151.98,452.98,168.02,454.14z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M247.44,308.3c-8.87,8.62-17.49,16.99-26.25,25.51c-5.84-5.38-12.22-9.72-19.4-12.85 c-7.11-3.09-14.5-5.03-22.52-5.67c0-11.98,0-23.91,0-36.21C205.39,280.51,227.87,290.71,247.44,308.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92.68,314.92c8.94,8.73,17.65,17.25,26.44,25.83c-9.28,11.75-14.68,24.88-15.52,39.87 c-12.68,0-25.24,0-38.22,0C66.77,355.54,76.01,333.84,92.68,314.92z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M168,327.19c0,9.49,0,18.79,0,28.19c-5.52,1.2-10.64,3.15-14.78,7.03c-8.44,7.9-11.85,17.62-9.29,28.92 c2.61,11.5,9.66,19.31,21.19,22.52c2.45,0.68,3.07,1.66,3.01,4.06c-0.17,7.3-0.07,14.61-0.07,21.92c0,0.76,0,1.52,0,2.28 c-25.99-1.22-50.13-23.86-52.28-51.03c4.63,0,9.24,0,14.01,0c0-3.52,0-6.75,0-10.26c-4.62,0-9.23,0-13.8,0 C112.83,357.88,142.29,327.57,168,327.19z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M231.49,380.63c-4.83,0-9.47,0-14.31,0c0,3.46,0,6.76,0,10.31c4.61,0,9.3,0,14.01,0 c-1.67,25.04-23.47,49.15-51.9,51.32c0-9.13,0-18.26,0-27.56c0.91-0.25,1.93-0.52,2.95-0.82c13.14-3.91,21.87-15.87,21.59-29.55 c-0.28-13.54-9.28-24.92-22.51-28.31c-1.64-0.42-2.23-1.06-2.21-2.79c0.09-8.61,0.04-17.22,0.04-26.19 c13.3,1.04,24.57,6.53,34.16,15.55C224.19,352.84,230.39,365.42,231.49,380.63z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M168.01,279.06c0,12.24,0,24.12,0,36.22c-16.17,1.23-30.17,7.41-42.12,18.52c-8.75-8.5-17.41-16.91-26.31-25.55 C119.13,290.41,141.81,280.95,168.01,279.06z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M179.21,454.26c15.87-1.24,29.84-7.13,41.63-17.92c8.89,8.65,17.62,17.14,26.41,25.69 c-19.31,17.61-42.06,26.63-68.04,28.74C179.21,478.52,179.21,466.45,179.21,454.26z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M281.52,380.68c-12.76,0-25.33,0-38.17,0c-0.88-14.86-6.13-28.07-15.12-39.3c8.58-8.99,16.99-17.81,25.33-26.55 C267.06,324.23,281.53,358.6,281.52,380.68z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.4,391.12c13.02,0,25.66,0,38.47,0c1.29,14.27,6.31,27,15.04,37.56c-8.63,9.08-17.11,18.01-25.82,27.18 C76.58,436.99,67.41,415.73,65.4,391.12z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M227.68,429.42c8.75-11.45,14.53-23.88,15.34-38.29c12.85,0,25.48,0,38.53,0 c-1.92,24.57-11.26,45.73-27.34,64.27C245.29,446.65,236.54,438.09,227.68,429.42z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M191.97,385.07c-0.02,9.95-8.58,18.45-18.53,18.39c-9.69-0.06-18.4-8.62-18.4-18.09 c0-10.46,8.42-18.86,18.82-18.78C183.68,366.66,191.99,375.14,191.97,385.07z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNoText);
export default __webpack_public_path__ + "static/media/logo-no-text.5aa08b1efb95557f5fe550df4b7a2e57.svg";
export { ForwardRef as ReactComponent };